import React, {ReactNode} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import DataPointInfo from './DataPointInfo';
import AssetPropertyInfo from './AssetPropertyInfo';
import {AssetInfoData} from './types';
import {InfoType} from './types';
import iconHardware from '../../../../assets/icon_hardware.svg';
import iconSoftware from '../../../../assets/icon_software.svg';
import iconCertificate from '../../../../assets/icon_certificate.svg';
import iconNetwork from '../../../../assets/icon_network.svg';
import iconFirmware from '../../../../assets/icon_firmware.svg';
import {ASSET_TYPE_PROPERTY} from '../../../../modules/ruleengine/config/consts';
import {ASSET_INFO_TEST_IDS} from './consts';
type Props = {
	type: InfoType;
	datapoints: Array<string>;
	assetData: AssetInfoData;
	assetType?: (string | null | undefined) | (boolean | null | undefined) | (number | null | undefined);
};
const InfoBlocks = {
	[InfoType.HARDWARE]: {
		icon: iconHardware,
		iconTestId: ASSET_INFO_TEST_IDS.HARDWARE_ICON,
		label: <Trans i18nKey="rafi.assetinfo.hardware">Hardware</Trans>
	},
	[InfoType.SOFTWARE]: {
		icon: iconSoftware,
		iconTestId: ASSET_INFO_TEST_IDS.SOFTWARE_ICON,
		label: <Trans i18nKey="rafi.assetinfo.software">Software</Trans>
	},
	[InfoType.NETWORK]: {
		icon: iconNetwork,
		iconTestId: ASSET_INFO_TEST_IDS.NETWORK_ICON,
		label: <Trans i18nKey="rafi.assetinfo.network">Network</Trans>
	},
	[InfoType.CERTIFICATE]: {
		icon: iconCertificate,
		iconTestId: ASSET_INFO_TEST_IDS.CERTIFICATE_ICON,
		label: <Trans i18nKey="rafi.assetinfo.certificate">Certificate</Trans>
	},
	[InfoType.FIRMWARE]: {
		icon: iconFirmware,
		iconTestId: ASSET_INFO_TEST_IDS.FIRMWARE_ICON,
		label: <Trans i18nKey="rafi.assetinfo.firmware">Firmware</Trans>
	}
};
type WrapperProps = {
	type: InfoType;
	children: ReactNode;
};
export const AssetInfoBlockWrapper = ({type, children}: WrapperProps) => {
	const infoBlock = InfoBlocks[type];
	return (
		<div className="asset-info-block" data-testid={ASSET_INFO_TEST_IDS.ASSET_INFO_BLOCK}>
			<h2 className="di header dividing asset-info-block-header">
				<img src={infoBlock.icon} className="asset-info-icon" data-testid={infoBlock.iconTestId} />
				<span data-testid={ASSET_INFO_TEST_IDS.ASSET_INFO_BLOCK_NAME}>{infoBlock.label}</span>
			</h2>
			{children}
		</div>
	);
};

const AssetInfoBlock = ({type, datapoints, assetData, assetType}: Props) => {
	return (
		<AssetInfoBlockWrapper type={type}>
			{assetType && <AssetPropertyInfo assetPropertyName={ASSET_TYPE_PROPERTY} assetPropertyValue={assetType} />}
			{datapoints.map((dpName) => (
				<DataPointInfo dataPointName={dpName} dataPointInfo={assetData[dpName]} key={dpName} />
			))}
		</AssetInfoBlockWrapper>
	);
};

export default AssetInfoBlock;
